import { render, staticRenderFns } from "./Rank.vue?vue&type=template&id=40f8a2cd&scoped=true&"
import script from "./Rank.vue?vue&type=script&lang=js&"
export * from "./Rank.vue?vue&type=script&lang=js&"
import style0 from "./Rank.vue?vue&type=style&index=0&id=40f8a2cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f8a2cd",
  null
  
)

export default component.exports